<template>
  <div class='admin-menu-container'>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo admin-menu-top"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="3" disabled>
        Admin Panel:
      </el-menu-item>
      <el-menu-item index="1" v-for='item in menu' :key='item'>
        {{ item }}
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      menu: [
        'Dashboard', 'Users', 'Super Resellers',
        'Resellers', 'Videos', 'TvShows', 'Epg', 
        'Five Star List', 'Video Reports',
      ],
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-menu-container {
  position: fixed;
  width: 100%;
  z-index: 10000000;

  & ::v-deep {
    .el-menu--horizontal>.el-menu-item, .el-menu--horizontal>.el-submenu .el-submenu__title {
      height: auto;
      line-height: initial;
      padding: 10px;
      border-bottom: none !important;
    }

    .el-menu.el-menu--horizontal {
      height: auto;
      background: #ab2c28;
    }

    .el-menu.el-menu--horizontal {
      border-bottom: none;
    }

    .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
    .el-menu--horizontal>.el-submenu:hover .el-submenu__title,
    .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
      background: transparent;
      color: black;
    }

    .el-menu-item.is-disabled {
      color: white;
      opacity: .6;
    }
  }
}

.el-menu--horizontal {
  z-index: 10000000 !important;
}
</style>